/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { navigate } from 'gatsby';

import JobsList from './JobsList';
import JobListFilter from './JobListFilter';

import Card from '@material-ui/core/Card';

import colors from '../../assets/colors';
import fontSize from '../../assets/fontSize';
import {
  generateInitialFilters,
  generateUrlWithParams,
  getUrlParams
} from '../../services/helpers';

const Container = styled.main`
  padding: 0;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  padding-bottom: 72px;

  @media (min-width: 500px) {
    padding: 1rem;
    height: calc(100vh - (97px + 2rem));
  }

  @media (min-width: 980px) {
    height: calc(100vh - (64px + 2rem));
  }
`;
const JobListColumn = styled.div`
  height: 100%;
  flex: 1;
`;
const FiltersColumn = styled.div`
  width: 35%;
  display: none;

  @media (min-width: 980px) {
    margin-right: 3rem;
    display: block;
  }
`;
const JobsListCard = styled(Card)`
  && {
    height: 100%;
    overflow: hidden;
    @media (max-width: 499px) {
      box-shadow: none;
    }
  }
`;
const JobsListContent = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 0.5rem 1rem 0;

  @media (min-width: 500px) {
    padding: 1rem 2rem 0;
  }
`;
const Blurb = styled.section`
  padding: 1rem;
  background-color: ${colors.warningPurple};
  color: ${colors.warningText};
  border-radius: 6px;
  padding: 1rem;
`;
const BlurbTitle = styled.h6`
  margin: 0;
  font-size: ${fontSize.medium};
`;
const BlurbDescription = styled.p`
  margin: 0;
  margin-top: 0.5rem;
  font-size: ${fontSize.medium};
`;

const SINGLE_FILTER = 1;
const NO_FILTERS = 0;
const JOBS_SEARCH_INDEX = ['/jobs', '/jobs/'];

const JobSearch = props => {
  const { blurb } = props;
  const [isMobile, setIsMobile] = useState(false);
  const [hasPerformedInitialLoad, setHasPerformedInitialLoad] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    jobType: [],
    employmentType: [],
    location: []
  });

  const updateWindowDimensions = () => {
    if (window.innerWidth <= 980 && !isMobile) {
      setIsMobile(true);
    } else if (window.innerWidth > 980 && isMobile) {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);

    updateWindowDimensions();

    return () => window.removeEventListener('resize', updateWindowDimensions);
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlArray = window?.location?.pathname?.split('/')?.filter(Boolean);
      const preselectedHelper = urlArray && urlArray[1]?.replace(/-/g, '_');
      const preselectedEmployment = urlArray && urlArray[2]?.replace(/-/g, '_');

      const jobTypeParams = getUrlParams('jobType', true);
      const employmentTypeParams = getUrlParams('employmentType', true);
      const locationParams = getUrlParams('location', true);

      setActiveFilters({
        jobType: generateInitialFilters(jobTypeParams, preselectedHelper),
        employmentType: generateInitialFilters(
          employmentTypeParams,
          preselectedEmployment
        ),
        location: generateInitialFilters(locationParams, null)
      });

      setHasPerformedInitialLoad(true);
    }
  }, []);

  // TODO: Clean up this
  const handleApplyFilters = (filterType, filters) => {
    const updatedFilters = { ...activeFilters };
    updatedFilters[filterType] = filters;

    if (
      updatedFilters?.jobType?.length === SINGLE_FILTER &&
      updatedFilters?.employmentType?.length === SINGLE_FILTER
    ) {
      const url = generateUrlWithParams(
        `/jobs/${updatedFilters?.jobType[0]}/${updatedFilters?.employmentType[0]}`,
        updatedFilters
      );
      setActiveFilters(updatedFilters);
      navigate(url);
    } else if (updatedFilters?.jobType?.length === SINGLE_FILTER) {
      const url = generateUrlWithParams(
        `/jobs/${updatedFilters?.jobType[0]}`,
        updatedFilters
      );
      setActiveFilters(updatedFilters);
      navigate(url);
    } else if (JOBS_SEARCH_INDEX.includes(window?.location?.pathname)) {
      const url = generateUrlWithParams('/jobs', updatedFilters);
      setActiveFilters(updatedFilters);
      window?.history?.replaceState(null, null, url);
    } else {
      const url = generateUrlWithParams(`/jobs`, updatedFilters);
      navigate(url);
    }
  };

  const resetFilters = () => {
    setActiveFilters({
      jobType: [],
      employmentType: [],
      location: []
    });
    navigate('/jobs');
  };

  const isShowingBlurb =
    activeFilters?.jobType?.length === SINGLE_FILTER ||
    (activeFilters?.jobType?.length === NO_FILTERS &&
      activeFilters?.employmentType?.length === NO_FILTERS &&
      activeFilters?.location?.length === NO_FILTERS);

  return (
    <>
      {isMobile && (
        <JobListFilter
          activeFilters={activeFilters}
          handleApplyFilters={handleApplyFilters}
          resetFilters={resetFilters}
          isMobile
        />
      )}
      <Container>
        <FiltersColumn>
          {!isMobile && (
            <JobListFilter
              activeFilters={activeFilters}
              handleApplyFilters={handleApplyFilters}
              resetFilters={resetFilters}
            />
          )}
        </FiltersColumn>
        <JobListColumn>
          <JobsListCard elevation={2}>
            <JobsListContent>
              {blurb && isShowingBlurb && (
                <Blurb>
                  <BlurbTitle>{blurb?.title}</BlurbTitle>
                  <BlurbDescription>{blurb?.description}</BlurbDescription>
                </Blurb>
              )}
              <JobsList
                activeFilters={activeFilters}
                hasPerformedInitialLoad={hasPerformedInitialLoad}
                resetFilters={resetFilters}
                isMobile={isMobile}
              />
            </JobsListContent>
          </JobsListCard>
        </JobListColumn>
      </Container>
    </>
  );
};

export default JobSearch;
